import { render } from "./log-location.vue?vue&type=template&id=ede7383c&scoped=true&ts=true"
import script from "./log-location.vue?vue&type=script&lang=ts"
export * from "./log-location.vue?vue&type=script&lang=ts"

import "./log-location.vue?vue&type=style&index=0&id=ede7383c&scoped=true&lang=css"

import exportComponent from "/opt/jenkins/workspace/WF-cloud-admin-beta/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ede7383c"]])

export default __exports__